<template>
  <div v-if="store" class="width-100">
    <!-- 헤더 좌우 패딩이 12픽셀이라 맞춤 -->
    <v-menu
      offset-y
      rounded
      :max-width="!$vuetify.breakpoint.mobile ? 768 - 24 : 'calc(100% - 24px)'"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn text block height="28" v-bind="attrs" v-on="on" class="pl-7 pr-6">
          <v-layout justify-center align-center>
            <span class="font-weight-bold">{{ store.businessLicenseNumber }} {{ store.name }}</span>
            <v-icon class="ml-2">mdi-chevron-down</v-icon>
          </v-layout>
        </v-btn>
      </template>
      <v-list two-line>
        <v-list-item
          v-for="item in accounts"
          :key="item.uuid"
          link
          :disabled="store.businessLicenseNumber === item.store.businessLicenseNumber"
          @click="switchAccount(item)"
        >
          <v-list-item-avatar width="22">
            <img
              v-if="store.businessLicenseNumber === item.store.businessLicenseNumber"
              src="@/assets/images/icons/etc-etc-checkbox-dn.svg"
            />
            <img v-else src="@/assets/images/icons/etc-etc-checkbox.svg" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title style="white-space: unset">{{ item.store.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.store.businessLicenseNumber }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  computed: {
    ...mapState('auth', ['me', 'switchableAccounts']),
    store() {
      return this.me?.store
    },
    accounts() {
      if (!this.switchableAccounts) {
        return [this.me]
      }
      // 현재 계정도 select 목록에 포함
      return [this.me, ...this.switchableAccounts]
    },
  },
  async created() {
    await this.getSwitchableAccounts()
  },
  methods: {
    ...mapActions('auth', ['getSwitchableAccounts', 'signout']),
    async switchAccount({ uuid }) {
      const {
        data: { token },
      } = await defaultApi.postUsersSwitch(uuid)
      this.signout()
      location.href = `/?secret_token=${token}`
    },
  },
}
</script>

<style lang="scss" scoped></style>
